import $ from 'jquery';
import Globals from '@/helpers/globals';

const { $body } = Globals;

const Tab = {
    init() {
        $body.on('click', '.js-tab-toggle', e => this.handleTab(e));
    },

    handleTab(e) {
        e.preventDefault();

        const $curr = $(e.currentTarget);
        const tabTarget = $curr.attr('href');

        $('.js-tab-panel').removeClass('open');
        $('.js-tab-toggle').removeClass('active');

        $(tabTarget).addClass('open');
        $curr.addClass('active');
    },
};

export default Tab;
